import { getNotificationsAll } from '../api/NotificationsApi';
import useAuthUser from '../hooks/useAuthUser';
import useBaseQuery from '../hooks/useBaseQuery';
import { INotificationFilteringOptions } from '../types';
import IQueryKeys from '../types/IQueryKeys';

export const useNotificationsAllQuery = (params?: INotificationFilteringOptions) => {
  const user = useAuthUser();

  return useBaseQuery([IQueryKeys.notificationAllKey, params], () => getNotificationsAll(params), {
    refetchInterval: 5000,
    enabled: user?.role === 'processor' || user?.role === 'merchant',
  });
};
